export default "__VITE_ASSET__DTHfZ6pA__"